import { render, staticRenderFns } from "./annotateStatusBox.vue?vue&type=template&id=f4ec5050&scoped=true&"
import script from "./annotateStatusBox.vue?vue&type=script&lang=js&"
export * from "./annotateStatusBox.vue?vue&type=script&lang=js&"
import style0 from "./annotateStatusBox.vue?vue&type=style&index=0&id=f4ec5050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ec5050",
  null
  
)

export default component.exports